import { render, staticRenderFns } from "./SchoolActivityList.vue?vue&type=template&id=44de33a8&scoped=true"
import script from "./SchoolActivityList.vue?vue&type=script&lang=js"
export * from "./SchoolActivityList.vue?vue&type=script&lang=js"
import style0 from "./SchoolActivityList.vue?vue&type=style&index=0&id=44de33a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44de33a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44de33a8')) {
      api.createRecord('44de33a8', component.options)
    } else {
      api.reload('44de33a8', component.options)
    }
    module.hot.accept("./SchoolActivityList.vue?vue&type=template&id=44de33a8&scoped=true", function () {
      api.rerender('44de33a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/schoolActivity/SchoolActivityList.vue"
export default component.exports